var display_length = "4";
$(document).ready(function () {

   var handle =  setInterval(vitalReviewsCheck, 2000);
   function vitalReviewsCheck() {
     $(".card__content_info").each(function (index, value) {
        if($(this).find('div.vtl-pr-review-stars-snippet').length !== 0){
           console.log("test");
        }else{ 
          $(this).prepend('<div class="vtl_ssct__anxiety-melting-sleep-edition-hypnotherapy"><div class="vtl-pr-review-stars-snippet" style="justify-content: center; margin-top: 0px; margin-bottom: 0px; font-size: 18px; color: rgb(0, 0, 0);"><div class="vtl-pr-stars-snippet vtl-pr-review-stars-snippet__stars" style="width: 5em; min-width: 5em;"><div class="vtl-pr-stars-snippet__layer vtl-pr-stars-snippet__back" style="color: rgb(63, 198, 20);"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M259.3 17.8 194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M259.3 17.8 194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M259.3 17.8 194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M259.3 17.8 194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M259.3 17.8 194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg></div><div class="vtl-pr-stars-snippet__layer vtl-pr-stars-snippet__front" style="width: 100%; color: rgb(63, 198, 20);"><div class="vtl-pr-stars-snippet__front-inner" style="width: 5em;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 0 0"><path fill="currentColor" d="M259.3 17.8 194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 0 0"><path fill="currentColor" d="M259.3 17.8 194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 0 0"><path fill="currentColor" d="M259.3 17.8 194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 0 0"><path fill="currentColor" d="M259.3 17.8 194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 0 0"><path fill="currentColor" d="M259.3 17.8 194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg></div></div></div><div class="vtl-pr-ss__inner-el">  (0)</div></div></div>');  
        }  
     });
     clearInterval(handle);
   }

   var pathname = window.location.pathname;  
   //animateNumber.js Used and animate the count up Start
   var aC = 0;
   if(pathname == "/"){
     $(window).scroll(function () {
        var oTop = $('.counterSec').offset().top - window.innerHeight;
        if (aC == 0 && $(window).scrollTop() > oTop) {
           $(".count-num").each(countUp);
            $(".count-num-decimal").each(countUpDecimal);
           aC = 1;
        }
     });
   }
   //animateNumber.js Used and animate the count up End

  //Mobile View in Load More Button add in Home featured collection Start
   var window_with = $(window).width();
   if (window_with < 961) {
      var button_display = 'N';
      $(".product_grid_mobile:first li").each(function (index, value) {
         if ((index + 1) > display_length) {
            $(this).hide();
            button_display = 'Y';
         }
      });
      if (button_display == 'Y') {
         $(".featured_collection_home:first").append('<div class="view_all_collection"><button type="button" class="button button--secondary" id="featured_collection_home_btn">View All Bestsellers</button></div>')
      }
      setTimeout(function() {
         var vital_reviews_under_title_html = $("#vital_reviews_under_title").html();
         $("#vital_reviews_under_title").remove();
         $(".show_info_mobile").find('.product__text').append("<div id='vital_reviews_under_title' data-source='os2'>"+ vital_reviews_under_title_html +"</div>"); 
      }, 1000);
     
   }
   //Mobile View in Load More Button add in Home featured collection End
  
   //Top parallax scroll
   $(window).on("load scroll", function () {
      var parallaxElement = $(".top_scroll"),
         parallaxQuantity = parallaxElement.length;
      window.requestAnimationFrame(function () {
         for (var i = 0; i < parallaxQuantity; i++) {
            var currentElement = parallaxElement.eq(i),
               windowTop = $(window).scrollTop(),
               elementTop = currentElement.offset().top,
               elementHeight = currentElement.height(),
               viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
               scrolled = windowTop - elementTop + viewPortHeight;
            currentElement.css({
               transform: "translate3d(0," + scrolled * -0.15 + "px, 0)"
            });
         }
      });
   });

   //Top parallax scroll
   $(window).on("load scroll", function () {
      var parallaxElement = $(".bottom_scroll"),
         parallaxQuantity = parallaxElement.length;
      window.requestAnimationFrame(function () {
         for (var i = 0; i < parallaxQuantity; i++) {
            var currentElement = parallaxElement.eq(i),
               windowTop = $(window).scrollTop(),
               elementTop = currentElement.offset().top,
               elementHeight = currentElement.height(),
               viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
               scrolled = windowTop - elementTop + viewPortHeight;
            currentElement.css({
               transform: "translate3d(0," + scrolled * 0.15 + "px, 0)"
            });
         }
      });
   });

   $('.marquee-left').marquee({
      direction: 'left',
      duration: 40000,
      delayBeforeStart: 0,
      duplicated: true,
      gap: 30,
      startVisible: true
   });

   $('.customer-slider .customer-list').slick({
      dots: true,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [{
            breakpoint: 1024,
            settings: {
               slidesToShow: 1,
               slidesToScroll: 1
            }
         },
         {
            breakpoint: 991,
            settings: {
               slidesToShow: 1,
               slidesToScroll: 1,
               centerMode: false
            }
         },
         {
            breakpoint: 480,
            settings: {
               slidesToShow: 1,
               slidesToScroll: 1,
               centerMode: false
            }
         }
      ]
   });

   $('.product-slider .product-list').slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [{
            breakpoint: 1024,
            settings: {
               slidesToShow: 3,
               slidesToScroll: 1
            }
         },
         {
            breakpoint: 768,
            settings: {
               slidesToShow: 2,
               slidesToScroll: 1,
               centerMode: false
            }
         },
         {
            breakpoint: 480,
            settings: {
               slidesToShow: 2,
               slidesToScroll: 1,
               centerMode: false
            }
         }
      ]
   });

   $('.stories_sec .stories_block').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [{
            breakpoint: 1024,
            settings: {
               slidesToShow: 3,
               slidesToScroll: 1
            }
         },
         {
            breakpoint: 991,
            settings: {
               slidesToShow: 2,
               slidesToScroll: 1,
               centerMode: false
            }
         },
         {
            breakpoint: 490,
            settings: {
               slidesToShow: 1,
               slidesToScroll: 1,
               centerMode: false
            }
         }
      ]
   });

   $(".accordion > li > h3").click(function () {
      if (false == $(this).next().is(':visible')) {
         $('.accordion ul').slideUp(300);
      }
      var classnm = $(this).parent('li').attr("class");
      $('.accordion > li').removeClass('active');
      $('.accordion > li[class=""]').removeAttr('class');
      $(this).next().slideToggle(300);
      if (classnm == "undefined" || classnm == "" || classnm == undefined) {
         $(this).parent('li').addClass('active');
      }
   });

  //Blog Page Tabs Code Start
  $("ul#blog_tabs li").click(function(e) {
    var tab_text = $(this).text();
    var var_text = tab_text.toLowerCase();
    var_text = var_text.replace(/ /g, "-");
    $("ul#blog_tabs li.active").removeClass("active");
    $(this).addClass("active"); 
    if(tab_text!="Show All"){
      $(".all_blog_articles").hide();
      $("."+var_text).show();
    }else{
      $(".specific_blog_articles").hide();
      $(".show_all_blog_articles").show();
    }
  });

  $(document).on("change", "#blog_select_filter", function () {
    var tab_text = $("#blog_select_filter option:selected").text();  
    var tab_href = $("#blog_select_filter option:selected").attr('href');
    if(tab_href!="" && tab_href!=undefined){
      var origin = window.location.origin 
      window.location.href = origin + "/"+tab_href;
    }else{
      $(".specific_blog_articles").hide();
      $(".show_all_blog_articles").show();
    }
  });
  //Blog Page Tabs Code End
  
});

//Mobile View in Load More Button add in Home featured collection Code Start
$(document).on("click", "#featured_collection_home_btn", function () {
   $(".product_grid_mobile:first li:hidden").each(function (index, value) {
      if ((index + 1) <= display_length) {
         $(this).show();
      }
   });
   if ($(".product_grid_mobile:first li:hidden").length == 0) {
      $(this).hide();
   }
});
//Mobile View in Load More Button add in Home featured collection Code End

//  animateNumber.js Used and animate the count up
function countUp() {
   var this_val = $(this).text().replace(/\,/g, '');
   $(this).animateNumber({
         number: this_val,
         numberStep: function (now, tween) { 
            var formatted = now.toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            var formatted_tmp = formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            $(tween.elem).text(formatted_tmp);
         }
      },
      1000
   );
}

//  animateNumber.js Used and animate the Decimal count up
function countUpDecimal() {
   var this_val = $(this).text().replace(/\,/g, '');
   $(this).animateNumber({
         number: this_val,
         numberStep: function (now, tween) {
            var formatted = now.toFixed(1).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            formatted = formatted.replace(".0", "");
            $(tween.elem).text(formatted);
         }
      },
      1000
   ); 
    if($(this).hasClass("count-num-2") ){
      setTimeout(function() {
        $(".count-num-2").append("+");
      }, 1000);
    } 
}
 
//Home Page Heade manu open and close to add class code Start
$(document).on("click", ".list-menu", function () {
   var this_val_aria = $(this).find(".header__menu-item").attr("aria-expanded");
   if (this_val_aria == 'true') {
      $(".header-wrapper").addClass("header_wrapper_menu");
   } else {
      $(".header-wrapper").removeClass("header_wrapper_menu");
   }
});

$(document).on("click", function () {
   var this_val_aria = $(".header__menu-item").attr("aria-expanded");
   if (this_val_aria == 'false') {
      $(".header-wrapper").removeClass("header_wrapper_menu");
   }
});
//Home Page Heade manu open and close to add class code End

$(document).on("click", ".continue_shopping_btn", function () { 
   var origin = window.location.origin
   window.location.href = origin + "/collections/all";
});

//collections page filter code Start
$(document).on("click", "input[name='prd_collections']", function () {
   var this_val = $(this).val();
   var origin = window.location.origin
   window.location.href = origin + "/collections/" + this_val;
});

$(document).on("click", "input[name='all_product_type']", function () {
   var this_val = $(this).val();
   var origin = window.location.origin
   window.location.href = origin + "/collections/types?q=" + this_val;
});

$(document).on("click", ".mobile_all_product_checkbox", function () {
  $(".mobile_all_product_checkbox").prop("checked", false);
  $(this).prop("checked", true);
});

$(document).on("click", "#mobile_apply_filters", function () {
  var this_val = $('.mobile_all_product_checkbox:checkbox:checked').val();
  var this_attr = $('.mobile_all_product_checkbox:checkbox:checked').attr("data-filters-type");
  if(this_attr == "mobile_prd_collections"){
    window.location.href = origin + "/collections/" + this_val;
  }else if(this_attr == "mobile_all_product_type"){
    window.location.href = origin + "/collections/types?q=" + this_val;
  }
});

$(document).on("click", ".view_ic", function (e) { 
   var this_val_view = $(this).attr('view-type');
  console.log(this_val_view);
   if (this_val_view == 'grid_view') {
      $("#product-grid").addClass("list_view");
   } else {
      $("#product-grid").removeClass("list_view");
   }
});

$(document).on("click", ".filter_collapse", function () {
  var data_div_id = $(this).attr("data-div-id");
  var obj = $(this);
   $("#"+data_div_id).slideToggle("slow", function () {
      if ($(this).is(":visible")) { 
         obj.find('span').removeClass("filter-arrow-up");
         obj.find('span').addClass("filter-arrow-down");
      } else { 
         obj.find('span').removeClass("filter-arrow-down");
         obj.find('span').addClass("filter-arrow-up");
      }
   });
});
//collections page filter code End

//collections and blog page remove pagination and add load more button js code Start
$(document).on("click", ".js-load-more", function () {
   var data_append_class_name = $(this).attr('data-append-class-name');
   var $this = $(this),
      totalPages = parseInt($('[data-total-pages]').val()),
      currentPage = parseInt($('[data-current-page]').val()) + 1;
   $this.attr('disabled', true);
   var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/, 'page=' + currentPage);
   $('[data-current-page]').val(currentPage);
   $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function (responseHTML) {
         $('.' + data_append_class_name).append($(responseHTML).find('.' + data_append_class_name).html());
      },
      complete: function () {
         if (currentPage == totalPages) {
            $this.hide();
         } else {
            $this.attr('disabled', false);
         }
         setTimeout(function() { 
          $(".card__content_info").each(function (index, value) {
            if($(this).find('div.vtl-pr-review-stars-snippet').length !== 0){
               //console.log("test");
            }else{ 
              $(this).prepend('<div class="vtl_ssct__anxiety-melting-sleep-edition-hypnotherapy"><div class="vtl-pr-review-stars-snippet" style="justify-content: center; margin-top: 0px; margin-bottom: 0px; font-size: 18px; color: rgb(0, 0, 0);"><div class="vtl-pr-stars-snippet vtl-pr-review-stars-snippet__stars" style="width: 5em; min-width: 5em;"><div class="vtl-pr-stars-snippet__layer vtl-pr-stars-snippet__back" style="color: rgb(63, 198, 20);"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M259.3 17.8 194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M259.3 17.8 194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M259.3 17.8 194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M259.3 17.8 194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M259.3 17.8 194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg></div><div class="vtl-pr-stars-snippet__layer vtl-pr-stars-snippet__front" style="width: 100%; color: rgb(63, 198, 20);"><div class="vtl-pr-stars-snippet__front-inner" style="width: 5em;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 0 0"><path fill="currentColor" d="M259.3 17.8 194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 0 0"><path fill="currentColor" d="M259.3 17.8 194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 0 0"><path fill="currentColor" d="M259.3 17.8 194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 0 0"><path fill="currentColor" d="M259.3 17.8 194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 0 0"><path fill="currentColor" d="M259.3 17.8 194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg></div></div></div><div class="vtl-pr-ss__inner-el">  (0)</div></div></div>');  
            }  
          });
         }, 1500);
      }
   })
});
//collections and blog page remove pagination and add load more button js code End

// Back to top button js start
window.theme = window.theme || {};
theme.backToTop = (function(){
  var backtotopClass = $('.js-back-to-top');
  $(window).scroll(function() {
    if ($(this).scrollTop() > 300) {
      backtotopClass.fadeIn('slow');
    } else {
      backtotopClass.fadeOut('slow');
    }
  });
  backtotopClass.on('click',function(){
    $('body,html').animate({scrollTop: 0}, 800);
  });
})()
// Back to top button js end


/* product page related product slider js start */
  
  var interval = setInterval(relatedProdSlider, 3000);
  function relatedProdSlider() {
   $('.related-products .product-grid').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows:true,
    responsive: [
      {
        breakpoint: 1220,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 840,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });
   $('.related-products .product-grid').on('init', function(event, slick){
        clearInterval(interval);
    });  
  }
  /* product page related product slider js end */

//Product page sample recording btn code Start
$(document).on("click", ".sample_recording_btn", function () {
  var data_type = $(this).attr("data-type"); 
  let vid = document.getElementById("myAudio"); 
  if(data_type=='play'){
    $(this).attr('data-type','pause');
    $(this).removeClass('audio_play').addClass('audio_pause');
    vid.play();
  }else{
    $(this).attr('data-type','play');
    $(this).removeClass('audio_pause').addClass('audio_play');
    vid.pause();
  }
});
//Product page sample recording btn code End

// Download app button redirect
// Select all buttons with the class "redirectButton"
const buttons = document.querySelectorAll('.redirectButton');

// Attach the click event listener to each button
buttons.forEach(function(button) {
    button.addEventListener('click', function(event) {
        event.preventDefault(); // Prevent the default link behavior

        // Check if the user is on a mobile device
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            // Check if the user is on iOS (iPhone or iPad)
            if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                // Redirect to the iOS App Store
                window.location.href = 'https://apps.apple.com/gb/app/clear-minds-hypnotherapy/id1600470480';
            } else if (/Android/i.test(navigator.userAgent)) {
                // Redirect to the Android Play Store
                window.location.href = 'https://play.google.com/store/apps/details?id=com.clearmindhypnotherapy.app&hl=en&gl=US';
            }
        } else {
            // Continue with the default link behavior (open in a new tab)
            window.open(this.href, '_blank');
        }
    });
});